module.exports = __webpack_public_path__ + "static/img/zhgl_08.69bae75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Images/zhgl_08.png
// module id = ItMK
// module chunks = 1